<template>
    <dashboard-container>

        <dashboard-section header="Active models">

            <template v-slot:additional>
                <router-link :to="{ name: 'CreateModel', params: { ...$route.params }, query: { ...$route.query }}" class="underline transition duration-150 text-secondary dark:text-secondary-300 hover:text-secondary-300 focus:outline-none focus:shadow-outline rounded-sm">+ Add new model</router-link>
            </template>

            <div class="flex flex-col space-y-4" v-if="currentProject">

                <dashboard-card v-for="model in activeModels" :key="model.id">
                    <router-link tag="a" :to="{ name: 'ModelPage', params: { modelId: model.id }}" class="w-full flex items-center justify-between">

                        <div class="flex items-center space-x-4">
                            <icon-svg icon="model" class="w-5"/>
                            <typography variant="p" class="font-semibold">{{ model.name }}</typography>
                        </div>

                        <div class="flex items-center space-x-4">
                            <span
                                class="rounded-full px-2 py-1 font-semibold uppercase bg-opacity-10"
                                style="font-size: 10px;"
                                :class="{
                                    'text-success bg-success':
                                        model.status === 'success',
                                    'text-error bg-error':
                                        model.status === 'error',
                                    'text-gray-600 bg-gray-500':
                                        model.status === 'info',
                                    'text-warning bg-warning':
                                        model.status === 'pending',
                                }"
                            >
                                {{ model.status }}
                            </span>
                            <icon-svg icon="fat-arrow-right" class="w-4"/>
                        </div>


                    </router-link>
                </dashboard-card>


                <typography variant="p" class="text-gray-600 dark:text-gray-400" v-show="activeModels.length === 0">You have no active models.</typography>

            </div>

        </dashboard-section>

    </dashboard-container>
</template>

<script>
import { LayoutComponents } from '@/modules/Dashboard/components'
import { currentProject, loading } from '@/mixins'
export default {
    name: "ModelsPage",
    metaInfo: {
      title: 'Models',
    },
    mixins: [ LayoutComponents, currentProject, loading ],

}
</script>